<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Reservations") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <!-- SELECT DROPDOWN -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$t('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}
                </b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <!-- Transaction Date From-->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReservationDetail.from_date"
                  v-on:click="clearDate(2)"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchReservationDetail.from_date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  v-validate="'required'"
                  :typeable="true"
                  @input="onchangeDate()"
                ></Datepicker>
                <label
                  :class="
                    fetchReservationDetail.from_date ? 'active' : ''
                  "
                >{{ $t("Reservation") }} {{ $t("fromdate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- Transaction Date To -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  v-if="fetchReservationDetail.to_date"
                  v-on:click="clearDate('to_date')"
                  class="btn-clearDate"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fetchReservationDetail.to_date"
                  name="selectenddate_3"
                  id="selectenddate_3"
                  v-validate="'required'"
                  :typeable="true"
                  @input="onchangeDate()"
                ></Datepicker>
                <label
                  :class="
                    fetchReservationDetail.to_date ? 'active' : ''
                  "
                >{{ $t("Reservation") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent.stop="onGetTransactionList"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }} {{ $tc("report") }}
            </button>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-end align-items-center mb-4">
          <div class="w-50">
            <b-form-input
              v-model="searchReservations"
              v-debounce:800="onSearchReservation"
              placeholder="Search "
            ></b-form-input>
          </div>
          <div class="d-flex"></div>
          <div class="d-flex align-items-center justify-content-end w-100">
            <div class="mx-2">
              <b-dropdown
                name="listview"
                id="listview"
                variant="outline-blue"
                class=""
              >
                <template v-slot:button-content>
                  {{ $tc("viewing") }}&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;Of&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                >{{ list.name }}
                </b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
        <div class="swc-report">
          <table class="swc-report-table mb-3" border="1">
            <thead>
            <tr>
              <th>{{ $tc("Reservation ID") }}</th>
              <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
              <th>{{ $tc("customer") }} {{ $tc("Number") }}</th>
              <th>{{ $tc("Booking") }} {{ $tc("Source") }}</th>
              <th>
                {{ $tc("reservation") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th>
                {{ $tc("show") }} {{ $tc("booking") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th>{{ $tc("Booking Code") }}</th>
              <th>{{ $tc("Seat Name") }}</th>
              <th>{{ $tc("Payment Type") }}</th>
              <th>{{ $tc("Payment Status") }}</th>
              <th>{{ $tc("Booking Status") }}</th>

            </tr>
            </thead>
            <tbody
              v-for="(user, userIndex) in reservationList"
              :key="userIndex"
              class="sph-report"
            >
            <tr>
              <td
                :style="
                  user.booking_status == false && user.payment_status == true
                    ? 'color:red'
                    : user.booking_status == true && user.payment_status == true
                      ? 'color:green'
                      : ''
                "
              >{{ user.reservation_id | filterNullUndefined  }}</td>
              <td>{{ user.customer_email_final || email_check ||  "-" }}</td>
              <td>{{ user.customer_mobile_final || mobile_check ||  "-" }}</td>
              <td>{{ user.bs_source ||   "-" }}</td>
              <td>{{ user.created_at | fulldatemonparse }}</td>
              <td>{{ user.actual_show_time | fulldatemonparse }}</td>
              <td>{{ user.sb_booking_code | filterNullUndefined }}</td>
              <td>{{ user.seat_name | filterNullUndefined }}</td>
              <td>{{ user.payment_type_actual_name | filterNullUndefined }}</td>
              <td>{{ user.payment_status_name | filterNullUndefined }}</td>
              <td>{{ user.booking_status_name | filterNullUndefined }}</td>
            </tr>
            </tbody>
            <tbody v-if="reservationList.length == 0">
            <tr>
              <td colspan="13">
                <!-- <p v-if="reservationList.length == 0" class="text-center">
                  {{ $tc("NoRecords") }}
                </p> -->
                <NoRecords/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <b-pagination
        v-if="reservationList.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
        class="my-3"
      ></b-pagination>
    </div>

  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import UserService from "@/services/UserService";
import MovieService from "@/services/MovieService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import _ from "lodash";
import scheduleService from "@/services/scheduleService";
import PosService from "@/services/PosService";
import Printd from "printd";
import NoRecords from "@/components/Partials/NoRecords.vue";
import {createQueryString} from "@/services/ApiHelper";

export default {
  components: {DatePicker, Multiselect, NoRecords},
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selectedFilterValue: "",
      filterValues: [],
      filterValuesCopy: [],
      searchFilterValues: "",
      isRoleID: true,
      reservationList: [],
      reservationListCopy: [],
      searchUserValue: "",
      searchUsers: [],
      isSearchLoading: false,
      schedules: [],
      selected_ssid: "",
      selected_show_time: null,

      selectedFilter: "",
      users: ["Screen", "Movie", "User", "Show Booking Code"],
      fetchReservationDetail: {
        date: "",
        cinema_id: null,
        ssb_code: "",
        show_date: "",
        show_date_to: null,
        from_date: "",
        to_date: null
      },
      filterkey: '',
      filtervalue: '',
      selectedCinema: "",
      Cinemas: [],
      EjsData: null,
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [],
      sendMailObj: [],
      currencyData: "",

      searchReservations: "",
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.getCurrencyCode();
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectCinema(null, CinemaObj);
    }

    console.log("transactions page route", this.$route);
    let queryparams = this.$route.query;

    if (queryparams.cinema_id && parseInt(queryparams.cinema_id)) {
      this.fetchReservationDetail.cinema_id = parseInt(queryparams.cinema_id);
    }

    // this.onGetTransactionList();
    this.getviewingnumber();
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(null, CinemaObj);
      }
    }
  },
  computed: {
    checkValidation() {
      return !!(
        this.fetchReservationDetail.from_date &&
        this.fetchReservationDetail.to_date
      );
    }
  },
  methods: {
    onSearchReservation() {
      this.currentPage = 1;
      this.onGetTransactionList();
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value
      };
      MasterService.GetActiveList(payload)
      .then(response => {
        const {data} = response;
        if (data && data.status && data.Records.length > 0) {
          this.currencyData = data.Records[0];
          console.log(this.currencyData, " this.currencyData")
        } else {
          // Show Error Message:
          console.log("data.message :", data.message);
        }
      })
      .catch(error => {
        // Catch Error:
        console.log("Catch Error on getActiveScreenByCinemaId :", error);
      });
    },
    sendMailToUpdate() {
    },
    sendMailToUser(obj) {
    },
    excelDownload(BASE_URL, type) {
      let payload = {
        cinema_id: this.fetchReservationDetail.cinema_id,
        from_date: this.fetchReservationDetail.from_date
          ? moment(this.fetchReservationDetail.from_date).format(
            "YYYY-MM-DD"
          )
          : null,
        filterkey: this.filterkey ? this.filterkey : null,
        filtervalue: this.filtervalue ? this.filtervalue : null,
        ss_id: this.selected_ssid || null,
        limit: 10000,
        currentPage: 1,
        type: type
      };
      payload["to_date"] = this.fetchReservationDetail
        .to_date
        ? moment(this.fetchReservationDetail.to_date).format(
          "YYYY-MM-DD"
        )
        : null;

      console.log(payload)
      let qs = createQueryString(payload);
      console.log(qs)
      window.open(`${BASE_URL}/api/admin/reports/v2/transactions${qs}`)

    },
    moment,
    getviewingnumber() {
      this.viewingnumbers = [
        {name: "All", id: 1},
        {name: "10", id: 2},
        {name: "20", id: 3},
        {name: "30", id: 3},
        {name: "40", id: 4},
        {name: "50", id: 5}
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    onChangePagination: function (event) {

      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.onGetTransactionList();
      } else {
        this.currentPage = event;
        this.onGetTransactionList();
      }
    },
    onPrintHandler: function (sb_id, cinema_id) {
      let loader = this.$loading.show();
      let isReprint = true;
      PosService.GetTicketEjs(sb_id, cinema_id, isReprint)
      .then(async response => {
        const {data} = response;

        this.EjsData = data;

        this.$nextTick(() => {
          loader.hide();
          const p = new Printd();
          if (this.$refs.onPrint && this.EjsData != null) {
            p.print(this.$refs.onPrint, []);
          }
        });
      })
      .catch(this._CatchError);
    },
    clearDate(type = 1) {
      this.currentPage = 1;
      this.reservationList = [];

      switch (type) {
        case 2:
        case "to_date":
          this.fetchReservationDetail.from_date = "";
          this.fetchReservationDetail.to_date = "";
          break;
      }
    },
    onchangeDate: _.debounce(function (query) {
      this.searchReservations = ""
      this.reservationList = [];
      this.currentPage = 1;
      // this.onGetTransactionList();
    }, 500),
    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },

    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({cine_id: cine_id})
      .then(response => {
        const {data} = response;
        if (data.status && data.Records && data.Records.length > 0) {
          this.Cinemas = data.Records;
          this.CinemasCopy = data.Records;
          this.Cinemas.map(x => {
            if (String(cine_id) === String(x.cine_id)) {
              // this.fetchReservationDetail.cinema_id = x.cine_id;
              // this.selectedCinema = x.cine_name;
              this.onSelectCinema(null, {
                cine_name: x.cine_name,
                cine_id: x.cine_id
              });
            }

            if (
              this.fetchReservationDetail &&
              this.fetchReservationDetail.cinema_id &&
              x.cine_id === this.fetchReservationDetail.cinema_id
            ) {
              this.selectedCinema = x.cine_name;
            }
          });
        } else {
          this.$toasted.show(data.message);
        }
      })
      .catch(this._CatchError);
    },

    onGetTransactionList: function () {
      // if(!this.fetchReservationDetail.cinema_id) this.$toasted.show("Please select cinema")

      if (
        (!this.fetchReservationDetail.to_date && !this.fetchReservationDetail.from_date) ||
        (this.fetchReservationDetail.to_date && !this.fetchReservationDetail.from_date) ||
        (!this.fetchReservationDetail.to_date && this.fetchReservationDetail.from_date)
      )
        this.$toasted.show("Please select Reservation date range properly");

      this.reservationList = [];
      if (
        this.fetchReservationDetail.cinema_id &&
        this.checkValidation
      ) {
        let loader = this.$loading.show();

        this.btenable = true;
        let payload = {
          cinema_id: this.fetchReservationDetail.cinema_id,
          from_date: this.fetchReservationDetail.from_date
            ? moment(this.fetchReservationDetail.from_date).format(
              "YYYY-MM-DD"
            )
            : null,
          to_date: this.fetchReservationDetail
            .to_date
            ? moment(this.fetchReservationDetail.to_date).format(
              "YYYY-MM-DD"
            )
            : null,
          // filterkey: this.filterkey ? this.filterkey : null,
          // filtervalue: this.filtervalue ? this.filtervalue : null,
          limit: this.perPage,
          currentPage: this.currentPage
        };
        if (!!this.searchReservations) payload.search_val = this.searchReservations

        MasterService.getReservationsDetail(payload)
        .then(response => {
          this.btenable = false;
          const {data} = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.reservationList = data.Records;
            this.reservationListCopy = data.Records;
            if (data.totalRows && data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue = this.perPage;
            } else if (data.totalRows) {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else if (data.Records && data.Records.length == 0) {
            this.rows = 0
            this.selectedvalue = '0'
            this.$toasted.show("No Records Found.");
          } else {
            this.rows = 0
            this.selectedvalue = '0'
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 100);
        });
      } else {
        this.$toasted.show("Invalid Selection");
      }
    },
    onSelectCinema: function (event, params) {
      this.searchCinema = "";
      this.searchReservations = "";
      this.onSearchCinema(null);
      this.$store.dispatch("selectDropdownCinema", params);
      this.selectedCinema = params.cine_name;
      this.fetchReservationDetail.cinema_id = params.cine_id;
      if (
        this.fetchReservationDetail.from_date
      ) {
        this.onGetTransactionList();
      } else {
        this.$toasted.show("Please select date");
      }
    },
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/reservationComponents/showReservations.vue